export default function timeFormat(
  date: Date,
  dateStyle: 'medium' | 'short' = 'short',
): string {
  return new Intl.DateTimeFormat('fa-IR', { dateStyle }).format(date)
}
